import NextLink from 'next/link'
import { useRouter } from 'next/router'
import {
  PaginationItem,
  Pagination as View,
  WORKSPACE_TAB
} from 'ui-components'
import { getWorkspaceLink } from 'utils'

import { mapsPerPage } from '~workspace/constants/maps'
import { useSearchMapsInCurrentWorkspace } from '~workspace/queries/useSearchMaps'

export function Pagination(props) {
  const router = useRouter()

  const { data } = useSearchMapsInCurrentWorkspace()

  const workspaceId = String(router.query.workspaceId)
  const workspaceName = String(router.query.workspaceName)
  const page = Number(router?.query?.page)

  return (
    <View
      page={page}
      total={data?.total || 0}
      limit={mapsPerPage}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          component={NextLink}
          href={getWorkspaceLink({
            workspaceId,
            workspaceName,
            tab: WORKSPACE_TAB.MAPS,
            page: item.page ?? 1
          })}
        />
      )}
    />
  )
}
